export default __webpack_public_path__ + "static/service-contracting-5-7641d5a85c41e8ef8368892454fb56a7.svg";